import PropTypes from 'prop-types';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatToast } from '@blocks-react/components/Toast';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { TOAST_VARIANT } from '@app/constants/commonConstants';
import styles from './Toast.module.scss';

const Toast = ({ variant, message, clearToastMessage }) => {
  return variant !== TOAST_VARIANT.NONE ? (
    <CatToastGroup verticalPosition="bottom" horizontalPosition="center">
      <CatToast
        variant={variant}
        onBlClose={clearToastMessage}
        className={styles['toast__max-width']}
      >
        {variant === TOAST_VARIANT.SUCCESS ? (
          <CatIconSuccess slot="before" />
        ) : (
          <CatIconWarningCircle slot="before" />
        )}
        <CatHeading variant="label-sm" className="text-break">
          {message}
        </CatHeading>
      </CatToast>
    </CatToastGroup>
  ) : null;
};
export default Toast;
Toast.propTypes = {
  variant: PropTypes.string,
  message: PropTypes.string,
  clearToastMessage: PropTypes.func
};
